import { Card } from 'antd';
import Meta from 'antd/lib/card/Meta';
import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import "./selectedprofilecard.css";

const SelectedProfileCard = ({selectedItems, handleUnselectItems, showCancel}) => {
  return (
    <Card className='profile-items-card selected-items-cards-container card-border'>
      <Meta
        title={(selectedItems.label)}
        description={selectedItems.misc}
      />
      {showCancel && (
        <div className='action-icons'>
          <CloseOutlined className='selected-items-cross-icon' onClick={() => handleUnselectItems(selectedItems)} />
        </div>
      )}
    </Card>
  )
}

export default SelectedProfileCard;